import { motion } from "framer-motion";
import { CONTACT } from "../lib/brand";

const RITUAIS = [
  {
    n: "I",
    key: "curadoria",
    title: "Curadoria",
    desc: "Minha leitura autoral sobre moda circular — o olhar que separa peça de qualquer coisa e transforma acervo em narrativa.",
    steps: ["Estudo de referências", "Direção editorial", "Composição de looks", "Publicação autoral"],
    cta: "Falar comigo",
  },
  {
    n: "II",
    key: "consultoria",
    title: "Consultoria pessoal",
    desc: "Uma experiência guiada por mim. Eu edito seu guarda-roupa, desenho composições autorais e resgato o desejo pelas suas próprias peças.",
    steps: ["Diagnóstico de estilo", "Sessão presencial", "Plano de composição", "Follow-up de estilo"],
    cta: "Agendar consultoria",
  },
  {
    n: "III",
    key: "voz",
    title: "Voz & Mídia",
    desc: "Palestras, entrevistas, painéis, colunas. Sou uma referência viva do movimento de moda circular no Brasil.",
    steps: ["Palestras & talks", "Entrevistas na mídia", "Painéis & mentorias", "Parcerias editoriais"],
    cta: "Me convidar",
  },
];

export default function Rituais() {
  return (
    <section
      id="rituais"
      data-testid="rituais-section"
      className="relative bg-cream-100 py-24 sm:py-40 border-t border-ink-800/15"
    >
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
        <div className="grid grid-cols-12 gap-6 lg:gap-16 items-end mb-16 sm:mb-24">
          <div className="col-span-12 lg:col-span-7">
            <div className="flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.3em] text-ink-800/60 mb-8">
              <span className="w-8 h-px bg-brick-500" />
              <span>Universos Herida</span>
            </div>
            <h2
              className="font-serif leading-[0.9] tracking-tight text-ink-800"
              style={{ fontSize: "clamp(3rem, 7vw, 7rem)" }}
            >
              Três frentes.<br />
              <span className="italic-serif text-brick-500">Uma só filosofia.</span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-4 lg:col-start-9">
            <p className="font-sans text-base sm:text-lg leading-relaxed text-ink-800/70">
              Atuo em três dimensões da moda circular — o olhar,
              a experiência guiada e a voz que amplifica o movimento.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-0 border-t border-ink-800/20">
          {RITUAIS.map((r, i) => (
            <motion.div
              key={r.key}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.8, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className={`relative p-8 lg:p-10 flex flex-col gap-8 group hover:bg-brick-500 hover:text-cream transition-colors duration-500 ${
                i < RITUAIS.length - 1 ? "lg:border-r" : ""
              } border-b lg:border-b-0 border-ink-800/20`}
              data-testid={`ritual-${r.key}`}
            >
              <div className="flex items-start justify-between">
                <span className="font-serif italic text-4xl text-brick-500 group-hover:text-cream transition-colors duration-500">
                  {r.n}.
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] opacity-60">
                  Universo {i + 1} / 3
                </span>
              </div>

              <h3
                className="font-serif leading-[0.95] tracking-tight"
                style={{ fontSize: "clamp(2rem, 3vw, 3rem)" }}
              >
                {r.title}
              </h3>

              <p className="font-sans text-sm sm:text-base leading-relaxed opacity-80 max-w-sm">
                {r.desc}
              </p>

              <ol className="mt-2 space-y-2 font-mono text-[11px] uppercase tracking-[0.24em]">
                {r.steps.map((s, si) => (
                  <li key={s} className="flex items-baseline gap-3 opacity-80">
                    <span className="opacity-60">0{si + 1}</span>
                    <span>{s}</span>
                  </li>
                ))}
              </ol>

              <a
                href={CONTACT.whatsapp}
                target="_blank"
                rel="noreferrer"
                data-testid={`ritual-cta-${r.key}`}
                className="mt-auto inline-flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.24em] border-b border-current pb-2 w-fit"
              >
                {r.cta} →
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
